<div class="pageheader">
  <div class="page-title">
    <h1>Document retention</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Maintenance_Action_DocumentRetentions_ShowLog'"
        [title]="'Document retention log'">
        <app-change-log-link-entity type="DocumentRetention"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div>
  <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='documentRetentions' [bizSetColumnChooser]="false"
    [bizSetAllowColumnReordering]="false" [bizSetGroupPanel]="false" [bizSetPager]="false"
    (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)"
    (onRowUpdating)="onRowUpdating($event)" (onEditingStart)="onEditingStart($event)"
    (onRowRemoving)="onRowRemoving($event)" (onCellPrepared)="onCellPrepared($event)">

    <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
      [allowDeleting]="allowDeleting">
      <dxo-popup title="Document retention (in days)" [showTitle]="true"></dxo-popup>

      <dxo-form [showRequiredMark]="true" requiredMark="*" [colCount]="2" [customizeItem]="customizeItem">
        <dxi-item dataField="DocumentTypeId"></dxi-item>
        <dxi-item dataField="DaysToKeepTrackingData"></dxi-item>
        <dxi-item dataField="DaysToKeepTrackingFields"></dxi-item>
        <dxi-item dataField="DaysToKeepInterchangeIn"></dxi-item>
        <dxi-item dataField="DaysToKeepMessageIn"></dxi-item>
        <dxi-item dataField="DaysToKeepCDM"></dxi-item>
        <dxi-item dataField="DaysToKeepInterchangeOut"></dxi-item>
        <dxi-item dataField="DaysToKeepTransportInLogs"></dxi-item>
        <dxi-item dataField="DaysToKeepTransportOutLogs"></dxi-item>
        <dxi-item dataField="DaysToKeepDocumentFlowStatus"></dxi-item>
        <dxi-item dataField="DaysToKeepBatchMessage"></dxi-item>
        <dxi-item dataField="DaysToKeepAdditionalFiles"></dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxi-column dataField="DocumentTypeId" caption="Document Type" editCellTemplate="singleDropDownBoxEditor"
      [calculateDisplayValue]="getDocumentTypeDisplayValue">
      <div>
        <dxo-lookup [dataSource]="documentTypes" valueExpr="Id">
        </dxo-lookup>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>


    <dxi-column dataField="DaysToKeepTrackingData" caption="Tracking Data" dataType="number">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="custom" [validationCallback]="validateNumber"
        message="The overall number of tracking data must be greater than the other kind of tracking data"
        reevaluate="true">
      </dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="DaysToKeepTrackingFields" caption="Tracking Fields" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepInterchangeIn" caption="Interchange In" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepMessageIn" caption="Message In" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepCDM" caption="CDM" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepInterchangeOut" caption="Interchange Out" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepTransportInLogs" caption="Transport In Logs" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepTransportOutLogs" caption="Transport Out Logs" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepDocumentFlowStatus" caption="Document Flow Status" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepBatchMessage" caption="Batch Messages" dataType="number">
    </dxi-column>

    <dxi-column dataField="DaysToKeepAdditionalFiles" caption="Additional Files" dataType="number"
      [calculateDisplayValue]="getAdditionalFileDisplayValue">
    </dxi-column>

    <dxi-column type="buttons" [fixed]="true" fixedPosition="right">
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
      <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
      </dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
      <app-change-log-link *bizPermissionRequired="'Maintenance_Action_DocumentRetentions_ShowLog'" [title]="'Log'"
        [showIcon]="false" classNames="dx-link">
        <app-change-log-link-entity type="DocumentRetention" [id]="cell.data.Id"></app-change-log-link-entity>
      </app-change-log-link>
    </ng-container>

    <div *dxTemplate="let cellInfo of 'singleDropDownBoxEditor'">
      @if (cellInfo.data.IsDefault !== true && cellInfo.data.IsUnknown !== true) {
      <div else elseBlock>
        <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="documentTypes" [(value)]="cellInfo.value"
          displayExpr="Name" valueExpr="Id" contentTemplate="contentTemplate">
          <div *dxTemplate="let e of 'contentTemplate'">
            <dx-data-grid [dataSource]="availableDocumentTypesForEditing" [remoteOperations]="true" [height]="250"
              [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true" [focusedRowKey]="cellInfo.value"
              [hoverStateEnabled]="true" keyExpr="Id"
              (onSelectionChanged)="onSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
              <dxi-column caption="Name" sortOrder="asc" width="200" dataField="Name"></dxi-column>
              <dxi-column caption="Description" width="400" dataField="Description"></dxi-column>
              <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
              <dxo-scrolling mode="virtual"></dxo-scrolling>
              <dxo-selection mode="single"></dxo-selection>
            </dx-data-grid>
          </div>
        </dx-drop-down-box>
      </div>
      }
      <div #elseBlock>
        @if (cellInfo.data.IsDefault === true) {
        <span>DEFAULT</span>
        }
        @if (cellInfo.data.IsUnknown === true) {
        <span>UNKNOWN</span>
        }
      </div>
    </div>
  </dx-data-grid>

  <dx-tooltip position="bottom">
    <div *dxTemplate="let data of 'content'">
      <div class='tooltipContent'>
        <div>{{toolTipText}}</div>
      </div>
    </div>
  </dx-tooltip>
</div>